import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Slider } from "@mui/material";

const DurationSlider = ({ open, onClose, onDurationSelect }) => {
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);

  const handleHoursChange = (_, value) => setHours(value);
  const handleMinutesChange = (_, value) => setMinutes(value);

  const handleConfirm = () => {
    onDurationSelect(hours * 60 + minutes);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Duration</DialogTitle>
      <DialogContent>
        <Box sx={{ marginBottom: 3 }}>
          <Typography gutterBottom>Hours</Typography>
          <Slider value={hours} onChange={handleHoursChange} step={1} marks min={0} max={23} valueLabelDisplay="on" />
        </Box>
        <Box>
          <Typography gutterBottom>Minutes</Typography>
          <Slider value={minutes} onChange={handleMinutesChange} step={1} marks min={0} max={59} valueLabelDisplay="on" />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DurationSlider;